import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from '../ui/TestimonialCard';
const testimonials = [{
  quote: 'Finally, clothes that fit without alterations. I feel so much more confident walking into a meeting.',
  author: 'Sarah J.',
  height: '5\'2"',
  outcome: 'Saved $400 in tailoring'
}, {
  quote: 'No more bunched sleeves or dragging hems. This completely changed how I shop for work clothes.',
  author: 'Maya R.',
  height: '5\'1"',
  outcome: 'Found perfect jeans'
}, {
  quote: "I look polished and intentional—not like I'm wearing someone else's clothes. It's a game changer.",
  author: 'Jen L.',
  height: '5\'3"',
  outcome: 'Wardrobe refresh'
}];
export function Testimonials() {
  return <section className="py-24 bg-white" data-id="element-140">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-142">
          <h2 className="text-3xl md:text-5xl font-bold text-text-primary mb-6" data-id="element-143">
            What Short Women Are Saying
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-144">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} delay={i * 0.1} data-id="element-145" />)}
        </div>
      </div>
    </section>;
}